// Main types for the Pemlab form application

// CSV row structure
export interface CSVRow {
  code: string;
  points: string;
  Question: string;
  titre_brique: string;
  texte_brique: string;
  produit_1_nom: string;
  produit_2_nom: string;
  produit_3_nom: string;
  produits_concaténés: string;
  Exclusions: string;
  alternatives: string;
  affichage: string;
  activate: string;
}

// Question structure after parsing
export interface Question {
  id: string;
  code: string;
  title: string;
  description?: string;
  emoji?: string;
  theme: QuestionTheme;
  isMultiple: boolean;
  options: QuestionOption[];
  products: string[];
  exclusions: string[];
  alternatives: Record<string, string>;
  points: number;
  displayCondition: 'all' | 'condition';
}

// Question option
export interface QuestionOption {
  id: string;
  value: string;
  label: string;
  code: string;
  products?: string[];
  exclusions?: string[];
  alternatives?: Record<string, string>;
  points: number;
  activatedQuestions?: string[];
}

// Question themes
export enum QuestionTheme {
  SITUATION = 'situation',
  SOPK = 'sopk',
  TROUBLES_DIGESTIFS = 'troubles_digestifs',
  REGLES = 'regles',
  FLUX = 'flux',
  DOULEURS_RAPPORTS = 'douleurs_rapports',
  SPM = 'syndrome_premenstruel',
  FATIGUE = 'fatigue',
  PATHOLOGIES = 'pathologies',
  ALIMENTATION = 'alimentation',
  SPORT = 'sport',
  AUTRE = 'autre',
}

// User answer
export interface Answer {
  questionId: string;
  values: string[];
  products?: string[];
  exclusions?: string[];
  alternatives?: Record<string, string>;
  timestamp: string;
  points: number;
}

// Client information
export interface ClientInfo {
  prenom: string;
  nom: string;
  email: string;
  telephone: string;
  entreprise?: string;
  acceptMarketing: boolean;
  acceptTerms: boolean;
}

// Form submission payload
export interface FormSubmission {
  client: ClientInfo;
  produits: string[];
  produitsBonus: string[];
  totalPoints: number;
  questionsReponses: Array<{
    code: string;
    question: string;
    reponse: string;
    points: number;
  }>;
  codesSelectionnes: string[];
  timestamp: string;
  resultPageUrl?: string;
  resultMailUrl?: string;
}

// API response
export interface APIResponse {
  success: boolean;
  message?: string;
  redirectUrl?: string;
}

// Product recommendation
export interface ProductRecommendation {
  code: string;
  name: string;
  count: number;
  reason: string[];
}

// Bonus level from CSV
export interface BonusLevel {
  points: number;
  products: string[];
}

// Error types
export interface FormError {
  field?: string;
  message: string;
  code?: string;
}
